import { IViewModel } from '../../interfaces/view-model.interface';

// Note:  this class is presently a dummy class used to trigger ETL logic that is under development.

export class SiteETLRequest implements IViewModel {
    public constructor() { }

    public id: number; // This value is not presently used.
}
